import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { StubAccessService } from '../access';
import { Observable } from 'rxjs';
import { Views } from '../access/interface';

@Injectable({ providedIn: 'root' })
export class AccessSalesOrderAdminViewGuard {
  private readonly access = inject(StubAccessService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.access.hasAccessToViews([Views.viewManageSalesOrders]).pipe(
      map((response) => {
        const hasAccess = response.get(Views.viewManageSalesOrders);
        if (hasAccess) {
          return true;
        } else {
          const accountGroupId = route.paramMap.get('businessId');
          const orderId = route.paramMap.get('orderId');
          return this.router.createUrlTree(['order-management', accountGroupId, 'sales-order', orderId]);
        }
      }),
    );
  }
}
